import { Component } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { BaseSite, BaseSiteService, isNotNullable } from '@spartacus/core';
import { OutletPosition } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { filter, map, switchMap, tap } from 'rxjs/operators';
import { EnvironmentService } from '../../../../features/services/environment.service';
import { GGProductSchemaBuilder } from '../../../../seo/builders/GGProductSchemaBuilder';

interface BV_ENABLED {
  active: string;
  enabled: boolean;
}
@Component({
  selector: 'app-product-schema-component',
  templateUrl: './product-schema.component.html',
  standalone: false,
})
export class ProductSchemaComponent {
  outletPosition: OutletPosition = OutletPosition.BEFORE;

  constructor(
    private sanitizer: DomSanitizer,
    private baseSiteService: BaseSiteService,
    private ggProductSchemaBuilder: GGProductSchemaBuilder,
    private environmentService: EnvironmentService
  ) {}

  bvEnabled$: Observable<BV_ENABLED> = this.baseSiteService.getActive().pipe(
    filter((active) => !!active), // Ensure 'active' is not falsy
    switchMap((activeBaseSite: string) =>
      this.baseSiteService.get(activeBaseSite).pipe(
        filter(isNotNullable),
        tap((baseSite: BaseSite) => {
          if (baseSite.baseStore) {
            this.ggProductSchemaBuilder.setBaseStore(baseSite.baseStore);
          }
        }),
        map((baseSite: BaseSite) => ({
          active: activeBaseSite,
          enabled: this.environmentService.getCurrentEnvironment().reviews.bvEnabled[activeBaseSite] ?? false,
        }))
      )
    )
  );

  schemaHtml$: Observable<SafeHtml | null> = this.bvEnabled$.pipe(
    switchMap((bv) =>
      this.ggProductSchemaBuilder
        .build(bv.active)
        .pipe(
          map((res) =>
            res && Object.keys(res).length !== 0
              ? (bv.enabled ? (delete res.review, delete res.aggregateRating) : null, this.getSafeHTML(res))
              : null
          )
        )
    )
  );

  getSafeHTML(jsonLD: { [key: string]: any }): SafeHtml {
    const json = jsonLD ? JSON.stringify(jsonLD, null, 2).replace(/<\/script>/g, '<\\/script>') : '';
    const html = `<script type="application/ld+json">${json}</script>`;
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
